import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { getDefaultLocale } from './i18n'
import i18nMixin from './i18n/mixin'
import { resolveMediaUrl } from '@/utils/media'
import { initSiteBranding } from '@/utils/siteBranding'
import { setupPageTitleGuard } from '@/utils/pageTitle'

Vue.config.productionTip = false
Vue.prototype.$media = resolveMediaUrl
Vue.mixin(i18nMixin)

const defaultLocale = getDefaultLocale()
document.documentElement.lang = defaultLocale === 'zh' ? 'zh-CN' : 'en'
initSiteBranding(defaultLocale)
setupPageTitleGuard(router)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
